import {useMemo} from 'react';

import {Grid, isFullyAccessibleGrid} from 'constants/SampleConstants';
import {InaccessibleInfoNode} from 'graphql-client/__generated/graphqlGlobalTypes';
import {QueryResultType, useSkippableBenchlingQuery} from 'graphql-client/BenchlingQuery';
import {isInaccessible} from 'graphql-client/InaccessibleInfo';
import {
  InaccessibleBioentitiesQuery,
  InaccessibleBioentitiesQueryVariables,
} from 'samples/grids/__generated/InaccessibleBioentitiesQuery';
import {INACCESSIBLE_BIOENTITIES_QUERY} from 'samples/grids/GridQueryUtil';
import {getContainerContentIdsFromGrid} from 'samples/grids/GridUtil';

const EMPTY_ARRAY: Array<string> = [];

export default function useGridContentAccessibility(grid: Grid | null): {
  status: QueryResultType;
  inaccessibleContainedItemIds: Array<string>;
} {
  const fullyAccessible = isFullyAccessibleGrid(grid);
  const contentIds = grid == null || !fullyAccessible ? [] : getContainerContentIdsFromGrid(grid);
  const result = useSkippableBenchlingQuery<
    InaccessibleBioentitiesQuery,
    InaccessibleBioentitiesQueryVariables
  >(INACCESSIBLE_BIOENTITIES_QUERY, {
    skip: contentIds.length === 0,
    variables: {ids: contentIds},
  });

  const resultData = result.type === QueryResultType.SUCCESS ? result.data : null;

  const inaccessibleContainedItemIds = useMemo(() => {
    if (grid == null || result.type !== QueryResultType.SUCCESS || resultData == null) {
      return EMPTY_ARRAY;
    }
    return resultData.bioentities
      .filter((result): result is InaccessibleInfoNode => isInaccessible(result))
      .map((result) => result.invalidId);
  }, [grid, result.type, resultData]);
  return {status: result.type, inaccessibleContainedItemIds};
}
